<template>
  <span
    class="badge me-2"
    :class="[
      variantClass,
      { 'badge-pill': pill },
      sizeClass
    ]"
  >
    <slot>{{ text }}</slot>
  </span>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  text: {
    type: [String, Number],
    default: ''
  },
  variant: {
    type: String,
    default: 'primary',
    validator: (value) => [
      'primary', 'secondary', 'success', 'danger', 'warning', 'info',
      'purple', 'orange', 'azure', 'teal', 'cyan', 'indigo',
      'red-lt', 'blue-lt', 'green-lt', 'yellow-lt', 'purple-lt', 'gray-500',
    ].includes(value)
  },
  pill: {
    type: Boolean,
    default: false
  },
  size: {
    type: String,
    default: '',
    validator: (value) => ['', 'sm', 'lg'].includes(value)
  }
});

const variantClass = computed(() => {
  // Handle light variants (e.g., red-lt, blue-lt)
  if (props.variant.endsWith('-lt')) {
    return `bg-${props.variant}`;
  }
  // Standard variants with white text
  return `bg-${props.variant} text-white`;
});

const sizeClass = computed(() => props.size ? `badge-${props.size}` : '');
</script>
